// extracted by mini-css-extract-plugin
module.exports = {"check":"br_bt","input":"br_bv","label":"br_bx","box":"br_bz","indeterminate":"br_b1"};